module.exports = __webpack_public_path__ + "static/media/LC-hörlurar.8bbfed65.png";